import styled from 'styled-components'

export const ThirdPageWrapper = styled.div`
  display: flex;
  height: 100%;

  .client-form__third-page__selects {
    flex: 1;
    height: 100%;
    padding: 0 5px;
    overflow-y: auto;
  }
`

export const FifthPageWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .client-form__fifth-page__comment {
    flex: 1;
    display: flex;
    align-items: center;
    max-height: 25%;
    position: relative;

    :not(:last-child) {
      margin-bottom: 12px;
    }

    &.client-form__fifth-page__comment--invisible {
      display: none;
    }

    .comment-label {
      flex: 0 0 245px;
      text-align: right;
      padding-right: 10px;
    }

    .lk-textarea__container,
    textarea {
      height: 100%;
    }
  }
`
